export default __webpack_public_path__ + "73423d9e812d2ef9d2b783592b3442cc.wav";